const GET_WISHLISTS_REQUEST = 'GET_WISHLISTS_REQUEST';
const GET_WISHLISTS_ERROR = 'GET_WISHLISTS_ERROR';
const GET_WISHLISTS_SUCCESS = 'GET_WISHLISTS_SUCCESS';

import * as backend from 'backend-helpers/wishlists';

const initState = {
    list: null,
    totalCount: 0
};

export default function wishlists(state = initState, action) {
    if (action.type === GET_WISHLISTS_REQUEST) {
        return {
            list: null,
            totalCount: 0
        }
    }

    if (action.type === GET_WISHLISTS_SUCCESS) {
        let {list, totalCount} = action.result.data;

        return {
            list,
            totalCount
        }
    }

    return state;
}

export function getWishlists(params) {
    return {
        types: [GET_WISHLISTS_REQUEST, GET_WISHLISTS_SUCCESS, GET_WISHLISTS_ERROR],
        promise: backend.getWishlists(params)
    }
}


// WEBPACK FOOTER //
// ./src/reducers/wishlists.js